import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { articleService } from '../services/api';

const PLACEHOLDER_IMG = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="800" height="400"><rect width="100%" height="100%" fill="#e5e7eb"/><text x="50%" y="50%" text-anchor="middle" fill="#6b7280" font-family="Inter, Arial, sans-serif" font-size="28">AI Digest</text></svg>');

export default function ArticlePage() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await articleService.getArticle(id);
        setArticle(res.data);
      } catch (e) {
        setArticle(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  if (!article) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold">Not found</h1>
        <p className="text-gray-600">Article could not be loaded.</p>
      </div>
    );
  }
  
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">{article.title}</h1>
      <div className="text-sm text-gray-600 mb-4">
        <span>{article.source}</span>
        <span className="mx-2">•</span>
        <span>{new Date(article.published_date).toLocaleString()}</span>
      </div>
      <div className="mb-6">
        <img
          src={article.image_url || PLACEHOLDER_IMG}
          alt={article.title}
          className="w-full h-auto rounded"
          onError={(e) => { e.currentTarget.src = PLACEHOLDER_IMG; }}
        />
      </div>
      <p className="text-gray-700 mb-6">{article.summary}</p>
      <a href={article.url} className="text-blue-600 hover:underline" target="_blank" rel="noreferrer">
        Read original
      </a>
    </div>
  );
}
